import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { connectRefinementList } from 'commons/react-instantsearch-dom-wrappers';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import ProductListingClearAllFiltersButton from '../ProductListingClearAllFiltersButton';
import ProductListingQuickshipFilter from '../ProductListingQuickshipFilter';
import DesktopProductListingListFilter from './DesktopProductListingListFilter';
import DesktopProductListingSearchFilter from './DesktopProductListingSearchFilter';
import ProductListingWidthRangeFilter from '../ProductListingWidthRangeFilter';
const DesktopProductListingSidebarFiltersUI = t0 => {
  const $ = _c(16);
  const {
    variant
  } = t0;
  const {
    filters: t1
  } = useProductListingPageContext();
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t1 || $[1] !== variant) {
    const filters = t1 === undefined ? [] : t1;
    const filtersWithoutColors = filters.filter(_temp);
    t4 = "pb-4";
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <ProductListingClearAllFiltersButton />;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    t2 = "flex flex-col gap-5";
    let t6;
    if ($[7] !== variant) {
      t6 = t7 => {
        const {
          id,
          label,
          options
        } = t7;
        if (id === "search") {
          return <DesktopProductListingSearchFilter key={id} />;
        }
        if (id === "quickship") {
          return <ProductListingQuickshipFilter key={id} />;
        }
        if (id === "widthRange") {
          return <ProductListingWidthRangeFilter key={id} showTitle={true} />;
        }
        if (variant === "advanced-search" && options.length === 0) {
          return null;
        }
        return <div key={id}><h3 className="text-base font-bold mb-2">{label}</h3><DesktopProductListingListFilter id={id} /></div>;
      };
      $[7] = variant;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    t3 = filtersWithoutColors.map(t6);
    $[0] = t1;
    $[1] = variant;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t3) {
    t6 = <div className={t2}>{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
const AlgoliaProductFiltersDesktop = connectRefinementList(DesktopProductListingSidebarFiltersUI);
AlgoliaProductFiltersDesktop.displayName = 'AlgoliaProductFiltersDesktop';
const DesktopProductListingSidebarFilters = t0 => {
  const $ = _c(2);
  const {
    variant
  } = t0;
  let t1;
  if ($[0] !== variant) {
    t1 = variant === "advanced-search" ? <AlgoliaProductFiltersDesktop attribute="type" facetOrdering={true} limit={500} variant={variant} /> : <DesktopProductListingSidebarFiltersUI />;
    $[0] = variant;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default DesktopProductListingSidebarFilters;
function _temp(filter) {
  return filter.id !== "color";
}